import React from 'react';
import i18n from '../../i18n';

export const getMessageSourceContent = (source?: string): React.ReactNode => {
  switch ((source || '').toLowerCase()) {
    case 'whatsapp':
      return (
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="currentColor"
          aria-label={i18n.t('whatsapp', { ns: 'conversations' })}
          role="img"
        >
          <path d="M12 2C6.48 2 2 6.26 2 11.53c0 1.85.56 3.58 1.52 5.04L2.3 22l5.65-1.47a10.26 10.26 0 0 0 4.05.82c5.52 0 10-4.26 10-9.53S17.52 2 12 2Zm0 17.47c-1.25 0-2.47-.28-3.57-.82l-.25-.12-3.35.87.9-3.15-.16-.26a7.28 7.28 0 0 1-1.13-3.86c0-4.23 3.4-7.67 7.57-7.67 4.18 0 7.58 3.44 7.58 7.67 0 4.23-3.4 7.67-7.58 7.67Zm4.16-5.73c-.23-.12-1.35-.67-1.56-.74-.2-.08-.35-.12-.5.12-.14.23-.57.74-.7.9-.13.15-.26.17-.49.06-.23-.12-.95-.34-1.82-1.08-.67-.57-1.12-1.28-1.25-1.5-.13-.23-.01-.35.1-.47.1-.1.23-.26.35-.39.11-.13.15-.23.23-.39.08-.15.04-.29-.02-.41-.06-.12-.5-1.2-.7-1.64-.18-.42-.36-.36-.5-.37h-.42c-.14 0-.38.05-.58.29-.2.23-.77.75-.77 1.83 0 1.08.8 2.12.91 2.27.12.15 1.56 2.43 3.86 3.3 2.3.86 2.3.57 2.72.54.42-.03 1.35-.55 1.54-1.08.19-.53.19-.98.13-1.08-.06-.1-.21-.16-.44-.28Z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-label={i18n.t('instagram', { ns: 'common' })}
          role="img"
        >
          <rect x="3" y="3" width="18" height="18" rx="5" ry="5" />
          <circle cx="12" cy="12" r="4" />
          <circle cx="17.5" cy="6.5" r="1.3" fill="currentColor" stroke="none" />
        </svg>
      );
    case 'telegram':
      return (
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-label={i18n.t('telegram', { ns: 'common' })}
          role="img"
        >
          <path d="M21 4 3 11l7 2 2 7 9-16Z" />
          <path d="m10 13 11-9" />
        </svg>
      );
    case 'sms':
      return i18n.t('sms', { ns: 'common' });
    case 'email':
      return i18n.t('email', { ns: 'common' });
    case 'webchat':
      return i18n.t('webchat', { ns: 'common' });
    case 'messenger':
      return i18n.t('messengerChannel', { ns: 'conversations' });
    case 'voice':
      return i18n.t('voice', { ns: 'common' });
    default:
      return i18n.t('internal', { ns: 'common' });
  }
};

export default getMessageSourceContent;